import { configureStore } from '@reduxjs/toolkit'
import authReducer from './store/authSlice'
import sidebarReducer from './store/sidebarSlice'

const store = configureStore({
  reducer: {
    auth: authReducer,
    sidebar: sidebarReducer,
  },
})

export default store
